<div class="public-layout" [class.public-layout--login]="!showHeader()">
  @if (showHeader()) {
    <app-public-header />
  }

  <main class="public-content">
    <router-outlet />
  </main>
</div>
